/* =========================================================
   1. INIT BUTTONS (ONLY CONSULTATION ID FIX)
========================================================= */

document.addEventListener('click', function (e) {
  const consultationBtn = e.target.closest('.menu-list__link');

  if (!consultationBtn) return;

  // 🔥 filter ONLY consultation item (anchor-based, not id-based)
  const isConsultation =
    consultationBtn.textContent.trim().toLowerCase().includes('consult') ||
    consultationBtn.getAttribute('href').includes('tel:');

  if (isConsultation) {
    e.preventDefault();
    showZForm_342829();
  }
});


/* =========================================================
   2. GLOBAL CLICK HANDLER (BOTH FORMS)
========================================================= */

document.addEventListener('click', function (e) {
  const consultationBtn = e.target.closest('#zf_button_342829');
  const presentationBtn = e.target.closest('[data-zoho="533623"]');

  if (consultationBtn) {
    e.preventDefault();
    showZForm_342829();
    return;
  }

  if (presentationBtn) {
    e.preventDefault();
    showZForm_533623();
    return;
  }
});


/* =========================================================
   3. ZOHO 342829 (CONSULTATION)
========================================================= */

function isGermanSite() {
  try {
    const host = window.location.hostname;

    if (host.includes("zemits.de")) return true;

    const lang = (document.documentElement.lang || "").toLowerCase();
    return lang.startsWith("de");
  } catch (e) {
    return false;
  }
}

(function () {
  try {

    if (document.readyState === "complete") {
      onloadActions_342829();
    } else {
      window.addEventListener("load", onloadActions_342829, false);
    }

    function onloadActions_342829() {
      constructDiv_342829();
    }

    function constructDiv_342829() {
      const iframeDiv = document.createElement("div");
      iframeDiv.id = "zoho_iframe_342829";
      iframeDiv.className = "zf_main_id_342829";

      const closeFormDiv = document.createElement("div");
      closeFormDiv.id = "deleteform_342829";
      closeFormDiv.className = "zf_lb_closeform_342829";
      closeFormDiv.tabIndex = 0;

      const containerDiv = document.createElement("div");
      containerDiv.className = "zf_lB_Container_342829";
      containerDiv.appendChild(iframeDiv);
      containerDiv.appendChild(closeFormDiv);

      const wrapperDiv = document.createElement("div");
      wrapperDiv.className = "zf_lB_Wrapper_342829";
      wrapperDiv.appendChild(containerDiv);

      const dimmerDiv = document.createElement("div");
      dimmerDiv.className = "zf_lB_Dimmer_342829";

      const mainDiv = document.createElement("div");
      mainDiv.id = "formsLightBox_342829";
      mainDiv.style.display = "none";
      mainDiv.appendChild(wrapperDiv);
      mainDiv.appendChild(dimmerDiv);

      document.body.appendChild(mainDiv);

      closeFormDiv.addEventListener("click", deleteZForm_342829);
    }
  } catch (e) {}
})();

function showZForm_342829() {
  const holder = document.getElementById("zoho_iframe_342829");

  if (holder && !holder.querySelector("iframe")) {
    loadZForm_342829();
  }

  const box = document.getElementById("formsLightBox_342829");
  if (box) {
    box.style.display = "block";
    document.body.style.overflow = "hidden";
  }
}

function deleteZForm_342829() {
  const box = document.getElementById("formsLightBox_342829");
  if (box) box.style.display = "none";

  document.body.style.overflow = "";

  const iframe = document.getElementById("zoho_iframe_342829")?.querySelector("iframe");
  if (iframe) iframe.remove();
}

function loadZForm_342829() {
  const container = document.getElementById("zoho_iframe_342829");
  if (!container || container.querySelector("iframe")) return;

  let url = isGermanSite()
    ? "https:\/\/forms.zohopublic.eu\/zemitsespana\/form\/RckrufAnfordern\/formperma\/-mIAY3tyHGfzVYxPDLii6swxvBi1EcXggPStekRTedg?zf_rszfm=1"
    : "https:\/\/forms.zohopublic.eu\/zemitsespana\/form\/Requestacall\/formperma\/o5JkhctX8QtIwTw13BnxDdqwZIjLUyy28VXSw74iGo4?zf_rszfm=1";

  const iframe = document.createElement("iframe");
  iframe.src = url;
  iframe.style.border = "none";
  iframe.style.width = "100%";
  iframe.style.minHeight = "500px";

  container.appendChild(iframe);
}


/* zoho popup */
(function () {
  try {
    if (document.readyState === "complete") {
      init_533623();
    } else {
      window.addEventListener("load", init_533623, false);
    }

    function init_533623() {
      // Створюємо popup один раз
      if (!document.getElementById("formsLightBox_533623")) {
        constructDiv_533623();
      }

      // Старі Zoho кнопки
      document.querySelectorAll(".zf_button").forEach(function (btn) {
        btn.style.display = "inline-block";
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          showZForm_533623("https:\/\/forms.zohopublic.eu\/zemitsespana\/form\/DownloadPresentation\/formperma\/QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4?zf_rszfm=1");
        });
      });

      // Нові кнопки з popup_link
      document.querySelectorAll(".zf-button.popup-button").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          showZForm_533623(btn.dataset.popupLink);
        });
      });
    }

    function constructDiv_533623() {
      var iframeDiv = document.createElement("div");
      iframeDiv.id =
        "QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4_533623";
      iframeDiv.className = "zf_main_id_533623";

      var closeFormDiv = document.createElement("div");
      closeFormDiv.id = "deleteform_533623";
      closeFormDiv.className = "zf_lb_closeform_533623";
      closeFormDiv.tabIndex = 0;

      var containerDiv = document.createElement("div");
      containerDiv.id = "containerDiv_533623";
      containerDiv.className = "zf_lB_Container_533623";
      containerDiv.appendChild(iframeDiv);
      containerDiv.appendChild(closeFormDiv);

      var wrapperDiv = document.createElement("div");
      wrapperDiv.className = "zf_lB_Wrapper_533623";
      wrapperDiv.appendChild(containerDiv);

      var dimmerDiv = document.createElement("div");
      dimmerDiv.className = "zf_lB_Dimmer_533623";
      dimmerDiv.onclick = deleteZForm_533623;

      var mainDiv = document.createElement("div");
      mainDiv.id = "formsLightBox_533623";
      mainDiv.style.display = "none";
      mainDiv.appendChild(wrapperDiv);
      mainDiv.appendChild(dimmerDiv);

      document.body.appendChild(mainDiv);
    }

    function showZForm_533623(url) {
      var holder = document.getElementById(
        "QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4_533623"
      );

      var iframe = holder.querySelector("iframe");

      if (!iframe) {
        loadZForm_533623(url);
      } else {
        iframe.src = url;
      }

      document.getElementById("formsLightBox_533623").style.display = "block";
      document.body.style.overflow = "hidden";
    }

    function deleteZForm_533623() {
      var box = document.getElementById("formsLightBox_533623");
      if (box) box.style.display = "none";
      document.body.style.overflow = "";
    }

    function loadZForm_533623(url) {
      var container = document.getElementById(
        "QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4_533623"
      );

      if (!container || container.querySelector("iframe")) return;

      var iframe = document.createElement("iframe");
      iframe.src = url || "https:\/\/forms.zohopublic.eu\/zemitsespana\/form\/DownloadPresentation\/formperma\/QTFgTZaTL2T_P5kFKgfG6SHhSfmqj4gc76GGwC6ayl4?zf_rszfm=1";
      iframe.style.border = "none";
      iframe.style.width = "100%";
      iframe.style.minHeight = "500px";

      container.appendChild(iframe);

      var closeBtn = document.getElementById("deleteform_533623");
      closeBtn.onclick = deleteZForm_533623;

      closeBtn.addEventListener("keydown", function (event) {
        if (
          event.key === "Enter" ||
          event.key === " " ||
          event.keyCode === 13 ||
          event.keyCode === 32
        ) {
          event.preventDefault();
          deleteZForm_533623();
        }
      });
    }
  } catch (e) {}
})();

/* slider */
document.querySelectorAll('[data-slides]').forEach(slider => {
  const track = slider.querySelector('.slider-track');
  const slides = Array.from(track.children);
  const wrapper = slider.closest('.slider-wrapper');
  const nextBtn = wrapper.querySelector('[data-next]');
  const prevBtn = wrapper.querySelector('[data-prev]');
  let index = 0;

  function updateSlide() {
    track.style.transform = `translateX(-${index * 100}%)`;
  }
  nextBtn.addEventListener('click', () => {
    index = (index + 1) % slides.length;
    updateSlide();
  });
  prevBtn.addEventListener('click', () => {
    index = (index - 1 + slides.length) % slides.length;
    updateSlide();
  });
});

document.querySelectorAll('.tlir-button[data-button-type]').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    const type = btn.dataset.buttonType;

    if (type === 'advice') {
      document.querySelector('#popup-advice').classList.add('active');
    } else if (type === 'virtual_demo') {
      document.querySelector('#popup-virtual-demo').classList.add('active');
    }
  });
});

/* Review Text overflow */
  function handleReviewOverflow() {
    document.querySelectorAll('.review-text').forEach(el => {
      el.style.overflowY = 'visible';
      el.style.maxHeight = 'none';

      if (el.scrollHeight > 210) {
        el.style.maxHeight = '210px';
        el.style.overflowY = 'auto';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', handleReviewOverflow);
  window.addEventListener('resize', handleReviewOverflow);

/* FAQ */
document.addEventListener('DOMContentLoaded', () => {

  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    question.addEventListener('click', () => {
      const isOpen = question.classList.contains('active');

      // Закриваємо всі інші (якщо треба)
      faqItems.forEach(i => {
        i.querySelector('.faq-question').classList.remove('active');
        i.querySelector('.faq-answer').style.maxHeight = null;
      });

      // Відкриваємо поточний
      if (!isOpen) {
        question.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

});

/* blocks fade in */
document.addEventListener('DOMContentLoaded', function () {
  const animateElements = document.querySelectorAll('.animate');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // щоб не запускати повторно
      }
    });
  }, { threshold: 0.2 });

  animateElements.forEach(el => observer.observe(el));
});

/* divider */
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.blog-details-wrapper');
  if (!wrapper) return;

  const children = Array.from(wrapper.children);

  children.forEach((el, index) => {
    if (index === children.length - 1) return; // last element

    const hr = document.createElement('hr');
    hr.className = 'blog-divider';
    el.after(hr);
  });
});

/* change urls depending from domain */
document.addEventListener('DOMContentLoaded', () => {
  const hostname = location.hostname;

  // Визначаємо, на який домен мають вести посилання
  const domains = {
    'zemits.it': 'https://zemits.it',
    'zemits.de': 'https://zemits.de',
    'zemits.at': 'https://zemits.at',
    'zemits.es': 'https://zemits.es',
    'zemits.ie': 'https://zemits.ie',
    'zemits.nl': 'https://zemits.nl',
    'zemits.eu': 'https://zemits.eu',
    'zemits-saudi.com': 'https://zemits-saudi.com',
    'zemits.ae': 'https://zemits.ae',
    'zemits.gr': 'https://zemits.gr',
    'zemits.li': 'https://zemits.li',
    'zemits.fi': 'https://zemits.fi',
  };

  const currentDomain = domains[hostname];

  if (!currentDomain) return;

  // Замінюємо посилання з основного домену zemits.eu
  document.querySelectorAll('a[href^="https://zemits.eu"]').forEach(link => {
    link.href = link.href.replace('https://zemits.eu', currentDomain);
  });

  // Окремо для zemits.at:
  // якщо посилання веде на німецький домен — залишаємо його на .at
  if (hostname === 'zemits.at') {
    document.querySelectorAll('a[href^="https://zemits.de"]').forEach(link => {
      link.href = link.href.replace('https://zemits.de', 'https://zemits.at');
    });
  }

  // Окремо для сторінки Sale на zemits.at
  if (hostname === 'zemits.at') {
    document.querySelectorAll('a[href="https://zemits.de/pages/sale"]').forEach(link => {
      link.href = 'https://zemits.at/pages/sale';
    });
  }
});

/* on scroll top product line become the most z-index */
document.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector('.product-top-line');

  if (!element) return;

  const sentinel = document.createElement('div');
  sentinel.style.height = '1px';
  sentinel.style.marginBottom = '-1px';

  element.parentNode.insertBefore(sentinel, element);

  const observer = new IntersectionObserver(
    ([entry]) => {
      element.classList.toggle('is-sticky', !entry.isIntersecting);
    },
    {
      threshold: 0
    }
  );

  observer.observe(sentinel);
});

/* if top product reaches footer form it hides */
document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('.product-top-line');
  const footerForm = document.querySelector('#footer-form');

  if (!sticky || !footerForm) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        sticky.classList.add('is-hidden');
      } else {
        sticky.classList.remove('is-hidden');
      }
    },
    {
      threshold: 0
    }
  );

  observer.observe(footerForm);
});

  if (window.location.pathname === '/pages/customer-support') {
    const section = document.querySelector(
      '#shopify-section-sections--27419042742604__section_f3Hn3d'
    );

    if (section) {
      section.style.display = 'none';
    }
  }